import { render, staticRenderFns } from "./PetInfoHeader.vue?vue&type=template&id=5ac480b0&scoped=true"
import script from "./PetInfoHeader.vue?vue&type=script&lang=js"
export * from "./PetInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./PetInfoHeader.vue?vue&type=style&index=0&id=5ac480b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac480b0",
  null
  
)

export default component.exports